import { enableProdMode, importProvidersFrom } from '@angular/core';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';



if (environment.production) {
  enableProdMode();
}

  try {
  await bootstrapApplication(AppComponent, {
    providers: [
      importProvidersFrom(AppModule) // This pulls in all your AppModule settings
    ]
  }); // <-- Added missing closing parenthesis and semicolon
} catch (error) {
  console.error('Application bootstrapping failed:', error); // <-- Added mandatory catch block
}
